import { BankAttributes, CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { BankTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/bank-type.enum";
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BankService } from './bank.service';
import { IAPIListResult, IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { ICreateBank } from './interfaces/create-bank.interface';
import { IUpdateBank } from './interfaces/update-bank.interface';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CompanyService } from '../../configuration/company/company.service.service';
import { AccountComponent } from './account/account.component';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { AccountTwoComponent } from './account-two/account-two.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-bank',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './bank.component.html',
  styleUrl: './bank.component.scss'
})
export class BankComponent implements OnDestroy{
  displayedColumns: string[] = [
    "name",
    "type",
    "company",
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<BankAttributes>([]);
  
  totalItems = 0
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof BankAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []
  typeBankList: string [] = Object.keys(BankTypeEnum)

  currentCreateBank: ICreateBank = this.initializeCreateBank();
  currentUpdateBank: IUpdateBank | undefined;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  selectedStatuses: [] = [];
  selectedStatusesBankType: [] = [];

  // Lazy loading flags
  loadFiltersData = false;
    
  constructor(
    private bankService: BankService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [null]
    });
   }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.bankService.getPaginateAllBank(options,
      this.selectedStatuses,
      this.selectedStatusesBankType,
      this.form.get("companyId").value
    ).subscribe({
      next: (res: IPaginationResult<BankAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener bancos","Cerrar",{ duration: 5000});
      },
    })
  }

  onClearFilter(){
    this.selectedStatuses = [];
    this.getList()
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateBank(): ICreateBank {
    return { code: "", name: "", companyId: "", type: null, accountIds:[]};
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      }
    });
  }

  getBankTypeLabel(bankType: string): string {
    const labels = {
      [BankTypeEnum.OWN]: 'Propio',
      [BankTypeEnum.EXTERNAL]: 'Externo',
    };
    return labels[bankType] || bankType;
  }

  openCreateModal(): void {
    this.getAllCompanies()
    this.currentCreateBank = this.initializeCreateBank();
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: '90%', disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBank());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(bank: BankAttributes): void {
    this.getAllCompanies()
    this.currentUpdateBank = { 
      ...bank,
      companyId: bank.company ? bank.company._id.toString() : ""
    };
    this.dialogRefEdit =this.dialog.open(this.editModal, { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateBank(bank._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBank(): void {
    this.bankService.create(this.currentCreateBank).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.getList();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateBank(id: string): void {
   if (this.currentUpdateBank) {
      const updatedBank: IUpdateBank = { ...this.currentUpdateBank };

      this.bankService.update(id, updatedBank).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.getList();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, bank: BankAttributes): void {
    const originalStatusId = bank.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBank = { ...bank, statusId: updatedStatusId };

    this.bankService.update(bank._id.toString(), updatedBank).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        bank.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(bank: BankAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: bank, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(bank._id.toString()));
  }

  delete(id: string): void {
    this.bankService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  openAccount(bank: BankAttributes): void{
    const dialogRef = this.dialog.open(AccountComponent, {
      width: '90%',
      data: bank,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined || result == "Cancel") {
      } else {
        if (result == 'success') {
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
